<template lang="pug">
.missions-page
  Breadcrumbs(:list="breadcrumbs")
  // MISSIONS
  template(v-if="!isRu")
    .missions-page--mobile
      template(v-if="currentGroup")
        h1.missions-page__title
          | {{ $t("quests") }}
          template(v-if="currentGroup")
            | {{ ' ' + currentGroup.title }}
        .missions-page__mobile-header
          .missions-page__back(@click="returnToGroups")
            img(:src="require('~/assets/img/icons/angle-left.svg')" alt="angle left")
          .missions-page__mobile-header-right
            span.missions-page__communicate-text(v-t="'communicateInOfferwallGroup'")
            a.missions-page__communicate-button(href="https://t.me/+zfWb09cbPyU0Y2Qy")
              img(src="https://cdn.gaming-goods.com/images/other/missions/Telegram.png")
        .missions-page__h1(v-t="'pickATaskCenter'")
        .missions-page__groups--inline
          .missions-page__group(v-for="group in missionsGroups" :key="group.id" @click="setGroup(group)" :class="{'missions-page__group--active': currentGroup && currentGroup.name === group.name}")
            img.missions-page__group-icon(:src="group.icon" :alt="group.title")
            //span.missions-page__group-title(v-t="group.title")
            span.missions-page__group-subtitle(v-t="group.subtitle")
        .missions-page__frame
          .missions-page__frame-shield(v-if="!isAuthorized" @click="clickOnFrame")
          MissionsList(:isOfferWall="currentGroup.isOfferWall" :offerWallUrl="currentGroup.offerWallLink()" :asyncOfferwallUrl="currentGroup.asyncOfferWallLink" :title="currentGroup.title" :key="currentGroup.title" :mode="currentGroup.mode || 'iframe'" :offerwallData="currentGroup")

    .missions-page--desktop
      .missions-page__desktop-header
        h1.missions-page__title
          | {{ $t("quests") }}
          template(v-if="currentGroup")
            | {{ ' ' + currentGroup.title }}
        .missions-page__desktop-header-right
          span.missions-page__communicate-text(v-t="'communicateInOfferwallGroup'")
          a.missions-page__communicate-button(href="https://t.me/+zfWb09cbPyU0Y2Qy")
            img(src="https://cdn.gaming-goods.com/images/missions/telegram.webp" width="20" alt="telegram")
            | Telegram
      client-only
        .missions-page__body
          //.missions-page__groups--column
          //  .missions-page__group(v-for="group in missionsGroups" :key="group.id" @click="setGroup(group)" :class="{'missions-page__group--active': currentGroup && currentGroup.name === group.name}")
          //    img.missions-page__group-icon(:src="group.icon" :alt="group.title")
          //    span.missions-page__group-title(v-t="group.title")
          //    span.missions-page__group-subtitle(v-t="group.subtitle")
          .missions-page__frame(v-if="currentGroup")
            .missions-page__frame-shield(v-if="!isAuthorized" @click="clickOnFrame")
            MissionsList(:isOfferWall="currentGroup.isOfferWall" :offerWallUrl="currentGroup.offerWallLink()" :asyncOfferwallUrl="currentGroup.asyncOfferWallLink" :title="currentGroup.title" :key="currentGroup.title" :mode="currentGroup.mode || 'iframe'" :offerwallData="currentGroup")
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MissionsList from '@/components/Missions/MissionsList'
import OfferwallService from '@/services/OfferwallService'
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import { create24MetricsScript } from '~/utils/24metrics'
import { createMeta } from '~/utils/meta'

export default {
  name: 'MissionsByNamePage',

  components: {
    Breadcrumbs,
    MissionsList
  },

  data () {
    return {
      currentGroup: undefined,
      authInterval: null,
      desktopIframeUrl: undefined
    }
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isAuthorized', 'isAdmin']),

    isRu () {
      return this.$i18n.locale === 'ru'
    },

    userId () {
      return this.user?.id
    },

    missionsGroups () {
      // const defaultUserId = `3_${Date.now()}`
      return OfferwallService.getOfferwallGroup(this.$axios, this.userId, undefined, this.isAdmin)
    },

    breadcrumbs () {
      return [
        { title: this.$t('quests'), to: '/missions' },
        { title: this.currentGroup ? this.$t('quests') + ' ' + this.currentGroup?.title : '' }
      ]
    }
  },

  watch: {
    currentGroup (newValue) {
      this.$router.push({
        query: this.$route.query,
        params: {
          name: newValue.name
        }
      })
    }
  },

  async mounted () {
    this.checkSelectedOfferwall()

    this.desktopIframeUrl = undefined
    // const defaultUserId = `3_${Date.now()}`
    if (this.currentGroup.desktopWallLink) {
      const url = await this.currentGroup.desktopWallLink(this.$axios, this.userId)
      if (typeof url === 'string') {
        this.desktopIframeUrl = url
      }
    } else {
      this.desktopIframeUrl = undefined
    }

    this.createScript()
  },

  beforeDestroy () {
    clearInterval(this.authInterval)
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    setGroup (group) {
      this.currentGroup = group
    },

    returnToGroups () {
      this.setGroup(undefined)
    },

    checkSelectedOfferwall () {
      const offerwallGroupName = this.$route.params.name
      console.log('offerwallGroupName', offerwallGroupName)

      if (offerwallGroupName) {
        this.setGroup(this.missionsGroups.find(group => group.name === this.$route.params.name))
      }
    },

    clickOnFrame () {
      this.showModal({
        component: 'Auth'
      })
    },

    createScript () {
      const date = new Date().getTime()

      const callback = (fingerprint, uuid) => {
        this.fingerprint = fingerprint
        this.uuid = uuid
      }

      create24MetricsScript(this.$el, this.$cookiz, this.$axios, { id: undefined, source: this.$route.params.name }, this.user?.id, 'open-offerwall-iframe', `i${this.user?.id}_${date}`, callback)
    }
  },

  head () {
    return createMeta.call(this, {
      title: this.$t('missionHeadTitle', { name: this.currentGroup?.title }),
      description: this.$t('missionHeadDescription', { name: this.currentGroup?.title }),
      sharingDescription: this.$t('missionHeadDescription', { name: this.currentGroup?.title })
    })
  },

  jsonld () {
    if (this.currentGroup?.title) {
      return {
        '@type': 'CreativeWorkSeries',
        name: `${this.$t('quests')} ${this.currentGroup?.title}`,
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingCount: 25,
          ratingValue: 5,
          bestRating: 5,
          worstRating: 0
        }
      }
    } else {
      return {}
    }
  }
}
</script>

<style scoped lang="scss">
.missions-page {
  margin: 32px 16px;

  @media (min-width: $breakpointTablet) {
    margin: 25px 40px;
  }

  &--mobile {
    margin-bottom: 150px;

    @media (min-width: $breakpointTablet) {
      display: none;
    }
  }

  &--desktop {
    display: none;

    @media (min-width: $breakpointTablet) {
      display: block;
      background-image: url("https://cdn.gaming-goods.com/images/other/missions/bg.png");
      background-repeat: no-repeat;
    }
  }

  &__back {
    img {
      width: 24px;
    }
  }

  &__h1 {
    margin-top: 35px;
    font-weight: 500;
    font-size: 20px;
    line-height: 18px;
    color: $white;
  }

  &__mobile-header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-image: url("https://cdn.gaming-goods.com/images/other/missions/bg.png");
    background-repeat: no-repeat;
    background-size: cover;

    &-right {
      display: grid;
      grid-template-columns: 120px 1fr;
      grid-gap: 16px;
    }
  }

  &__desktop-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-right {
      display: grid;
      grid-template-columns: 160px 1fr;
      grid-gap: 20px;

      &--line {
        width: 100%;
        margin-left: 24px;
        border-top: 1px solid $blue-grey40;
      }
    }
  }

  &__communicate {
    &-text {
      width: 120px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: $white;

      @media (min-width: $breakpointTablet) {
        font-size: 18px;
        line-height: 24px;
        width: 160px;
      }
    }

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      background-color: #2ca3d6;
      border-radius: 8px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: $white;

      @media (min-width: $breakpointTablet) {
        padding: 12px 24px;
        height: max-content;

        img {
          margin-right: 10px;
        }
      }
    }
  }

  &__title {
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 24px;
    color: $white;

    @media (min-width: $breakpointTablet) {
      margin-top: 60px;
      margin-bottom: 48px;
      font-size: 40px;
      line-height: 48px;
    }
  }

  &__groups {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;

    &--inline {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 8px;
      overflow-x: auto;
      padding-bottom: 20px;
      margin: 26px 0 32px;
      height: 175px;
      overflow-y: auto;
    }

    &--column {
      display: grid;
      grid-template-columns: 256px;
      grid-gap: 8px;
      height: max-content;
    }
  }

  &__group {
    background-color: $blue-grey70;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 12px;
    border-radius: 8px;
    cursor: pointer;

    @media (min-width: $breakpointTablet) {
      flex-direction: column;
      justify-content: flex-start;
    }

    &--active {
      background-color: $primary60;
    }

    &-icon {
      object-fit: contain;
      height: 20px;

      @media (min-width: $breakpointTablet) {
        height: auto;
        margin-bottom: 18px;
      }
    }

    &-title {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      color: $white;
      margin-bottom: 8px;
    }

    &-subtitle {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: $blue-grey10;
    }
  }

  &__body {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 56px;
  }

  &__frame {
    position: relative;

    &-shield {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      z-index: 1;
    }
  }
}
</style>
